module.exports = __webpack_public_path__ + "static/media/quick-assessment.aa484df5.png";